import React, { useEffect, useState } from "react";
import * as RB from "react-bootstrap";
import * as utils from "../../Utils/comman";
import Select from "react-select";

import { Link, useLocation, useNavigate } from "react-router-dom";
import { AddCircle, Eye, Trash } from "iconsax-react";

function PopupGiftForm(props) {
  const [itemList, setItemList] = useState([]);
  const [giftGroups, setGiftGroups] = useState([
    {
      description: "",
      items: [
        {
          itemId: "",
          qty: "",
          value: 0,
        },
      ],
    },
  ]);
  const [modalImage, setModalImage] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [zoomLevel, setZoomLevel] = useState(1);
  const [validated, setValidated] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [deletedItemIds, setDeletedItemIds] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();

  const queryParams = new URLSearchParams(location.search);
  useEffect(() => {
    getItemList();
  }, []);

  const getItemList = () => {
    const bodyFormData = new FormData();
    bodyFormData.append("id", "");
    bodyFormData.append("page", 1);
    bodyFormData.append("per_page", 100);

    utils
      .callAPI("post", `/sales/getmarketingList`, bodyFormData)
      .then((res) => {
        setItemList(res?.result || []);
      })
      .catch(() => setItemList([]));
  };

  const handleGroupChange = (groupIndex, field, value) => {
    const updatedGroups = [...giftGroups];
    updatedGroups[groupIndex][field] = value;
    setGiftGroups(updatedGroups);
  };

  const handleItemChange = (groupIndex, itemIndex, field, value) => {
    const updatedGroups = [...giftGroups];
    const selectedItem = itemList.find(
      (item) => item.id === updatedGroups[groupIndex].items[itemIndex].itemId,
    );

    if (field === "itemId") {
      updatedGroups[groupIndex].items[itemIndex].itemId = value;
      updatedGroups[groupIndex].items[itemIndex].qty = "";
      updatedGroups[groupIndex].items[itemIndex].value = 0;
    } else if (field === "qty") {
      const price = selectedItem ? parseFloat(selectedItem.item_price) : 0;
      updatedGroups[groupIndex].items[itemIndex].qty = value;
      updatedGroups[groupIndex].items[itemIndex].value = value * price;
    }

    setGiftGroups(updatedGroups);
  };

  const addGroup = () => {
    setGiftGroups([
      ...giftGroups,
      {
        description: "",
        items: [
          {
            itemId: "",
            qty: "",
            value: 0,
          },
        ],
      },
    ]);
  };

  const removeGroup = (index) => {
    const updatedGroups = [...giftGroups];
    updatedGroups.splice(index, 1);
    setGiftGroups(updatedGroups);
  };

  const addItemToGroup = (groupIndex) => {
    const updatedGroups = [...giftGroups];
    updatedGroups[groupIndex].items.push({
      itemId: "",
      qty: "",
      value: 0,
    });
    setGiftGroups(updatedGroups);
  };

  const removeItemFromGroup = (groupIndex, itemIndex) => {
    const updatedGroups = [...giftGroups];
    const removedItem = updatedGroups[groupIndex].items[itemIndex];

    if (removedItem.dbId) {
      const selectedItem = itemList.find((i) => i.id === removedItem.itemId);
      setDeletedItemIds((prev) => [
        ...prev,
        {
          id: removedItem.dbId,
          marketing_material_id: removedItem.itemId,
          qty: removedItem.qty,
          price: selectedItem?.item_price || 0,
          total:
            parseFloat(selectedItem?.item_price || 0) *
            parseInt(removedItem.qty || 0),
        },
      ]);
    }

    updatedGroups[groupIndex].items.splice(itemIndex, 1);
    setGiftGroups(updatedGroups);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
    } else {
      setIsSubmit(true);
    }
  };

  useEffect(() => {
    if (isSubmit) {
      const bodyFormData = new FormData();

      if (props.rowData && Object.keys(props.rowData).length > 0) {
        bodyFormData.append("id", props?.rowData?.id || "");
      }

      // Append description (assuming only one group for simplicity)
      bodyFormData.append("description", giftGroups[0]?.description || "");

      // Build req_items array
      const allItems = [];
      giftGroups.forEach((group) => {
        group.items.forEach((item) => {
          const selectedItem = itemList.find((itm) => itm.id === item.itemId);
          if (selectedItem) {
            allItems.push({
              id: item?.dbId || 0, // Use existing DB ID if available, else 0
              marketing_material_id: item.itemId,
              qty: item.qty,
              price: selectedItem.item_price,
              total:
                parseFloat(selectedItem.item_price) * parseInt(item.qty || 0),
            });
          }
        });
      });

      bodyFormData.append("req_items", JSON.stringify(allItems));
      bodyFormData.append("status", "0");
      bodyFormData.append("reject_reason", "");
      bodyFormData.append("delete_req_items", JSON.stringify(deletedItemIds));

      utils
        .callAPI("post", "/meeting/popupgift/save", bodyFormData)
        .then((res) => {
          queryParams.delete("id");

          setIsSubmit(false);
          props.onChange({ mode: "list" });
        })
        .catch(() => {
          setIsSubmit(false);
        });
    }
  }, [isSubmit]);

  const handleBackClick = () => {
    const propdata = {
      mode: "list",
    };
    props.onChange(propdata);
  };

  useEffect(() => {
    if (props.rowData && Object.keys(props.rowData).length > 0) {
      const { description = "", req_items = [] } = props.rowData;

      const items = req_items.map((item) => ({
        itemId: item.marketing_material_id,
        qty: String(item.qty || ""), // ensure it's a string for controlled input
        value: parseFloat(item.total || 0),
        dbId: item.id, // used to track for deletion
      }));

      setGiftGroups([
        {
          description,
          items,
        },
      ]);
    }
  }, [props.rowData]);

  return (
    <>
      <div className="section-body ">
        <RB.Card className="">
          <RB.Card.Header>
            <h4>Add</h4>
            <div className="card-header-action">
              <Link
                className="btn btn-underline me-2"
                onClick={handleBackClick}
              >
                Back
              </Link>
            </div>
          </RB.Card.Header>
          <RB.Card.Body>
            <RB.Form noValidate validated={validated} onSubmit={handleSubmit}>
              {giftGroups.map((group, groupIndex) => (
                <>
                  {group.items.map((item, itemIndex) => (
                    <RB.Row key={itemIndex} className="align-items-end mb-3">
                      <RB.Col md={4}>
                        <div className="d-flex align-items-end gap-2">
                          <div className="flex-grow-1 floating-label-fancy">
                            <Select
                              className="bom-productName-select"
                              classNamePrefix="react-select"
                              options={itemList.map((item) => ({
                                value: item.id,
                                label: item.item_name,
                              }))}
                              value={
                                item.itemId
                                  ? {
                                      value: item.itemId,
                                      label:
                                        itemList.find(
                                          (i) => i.id === item.itemId,
                                        )?.item_name || "",
                                    }
                                  : null
                              }
                              onChange={(selectedOption) =>
                                handleItemChange(
                                  groupIndex,
                                  itemIndex,
                                  "itemId",
                                  selectedOption ? selectedOption.value : "",
                                )
                              }
                              placeholder="Select Item"
                              isClearable
                            />
                          </div>

                          {item.itemId &&
                            (() => {
                              const selectedItem = itemList.find(
                                (i) => i.id === item.itemId,
                              );
                              if (selectedItem?.item_image) {
                                return (
                                  <RB.Button
                                    size="sm"
                                    className="btn-circle mt-1"
                                    onClick={() => {
                                      setModalImage(selectedItem.item_image);
                                      setShowModal(true);
                                    }}
                                    title="Preview Image"
                                  >
                                    <Eye size={16} />
                                  </RB.Button>
                                );
                              }
                              return null;
                            })()}
                        </div>
                      </RB.Col>

                      <RB.Col md={3}>
                        <RB.InputGroup className="has-validation">
                          <RB.FloatingLabel
                            label="Quantity"
                            className="floating-label-fancy flex-grow-1"
                          >
                            <RB.Form.Control
                              type="text"
                              placeholder="Qty"
                              value={item.qty}
                              // Red border only when Max is reached
                              className={`${
                                Number(item.qty) > 0 &&
                                Number(item.qty) ===
                                  Number(
                                    itemList.find((i) => i.id === item.itemId)
                                      ?.Available_qty,
                                  )
                                  ? "border-danger"
                                  : ""
                              }`}
                              onChange={(e) => {
                                const val = e.target.value.replace(/\D/g, "");
                                const selectedItem = itemList.find(
                                  (i) => i.id === item.itemId,
                                );

                                if (!selectedItem) {
                                  handleItemChange(
                                    groupIndex,
                                    itemIndex,
                                    "qty",
                                    val,
                                  );
                                  return;
                                }

                                const maxAvailable = Number(
                                  selectedItem.Available_qty || 0,
                                );
                                const enteredQty = Number(val || 0);

                                let finalValue = val;
                                if (val !== "" && enteredQty > maxAvailable) {
                                  finalValue = maxAvailable.toString();
                                }

                                handleItemChange(
                                  groupIndex,
                                  itemIndex,
                                  "qty",
                                  finalValue,
                                );
                              }}
                              required
                            />
                          </RB.FloatingLabel>
{/* 
                          {item.itemId && (
                            <RB.InputGroup.Text
                              className={`bg-white border-start-0 ${
                                Number(item.qty) >=
                                (itemList.find((i) => i.id === item.itemId)
                                  ?.Available_qty || 0)
                                  ? "text-danger fw-bold"
                                  : "text-muted"
                              }`}
                              style={{ borderTop:"none",borderRight:'none' }}
                            >
                              /{" "}
                              {itemList.find((i) => i.id === item.itemId)
                                ?.Available_qty || 0}
                            </RB.InputGroup.Text>
                          )} */}
                        </RB.InputGroup>
                      </RB.Col>

                      <RB.Col md={3}>
                        <RB.FloatingLabel
                          label="Value"
                          className="floating-label-fancy"
                        >
                          <RB.Form.Control
                            type="text"
                            value={item.value}
                            // disabled
                            readOnly
                          />
                        </RB.FloatingLabel>
                      </RB.Col>

                      <RB.Col md={2} className="d-flex gap-2">
                        {/* Show only Remove if NOT the last item */}
                        {itemIndex !== group.items.length - 1 &&
                          group.items.length > 1 && (
                            <RB.Button
                              className="btn-circle"
                              variant="danger"
                              onClick={() =>
                                removeItemFromGroup(groupIndex, itemIndex)
                              }
                            >
                              <Trash />
                            </RB.Button>
                          )}

                        {/* Show only Add if this is the last item */}
                        {itemIndex === group.items.length - 1 && (
                          <>
                            {group.items.length > 1 && (
                              <RB.Button
                                className="btn-circle"
                                variant="danger"
                                onClick={() =>
                                  removeItemFromGroup(groupIndex, itemIndex)
                                }
                              >
                                <Trash />
                              </RB.Button>
                            )}
                            <RB.Button
                              className="btn-circle"
                              onClick={() => addItemToGroup(groupIndex)}
                            >
                              <AddCircle />
                            </RB.Button>
                          </>
                        )}
                      </RB.Col>
                    </RB.Row>
                  ))}

                  <RB.FloatingLabel label="Description" className="mt-3">
                    <RB.Form.Control
                      as="textarea"
                      rows={2}
                      value={group.description}
                      onChange={(e) =>
                        handleGroupChange(
                          groupIndex,
                          "description",
                          e.target.value,
                        )
                      }
                      placeholder="Enter description"
                    />
                  </RB.FloatingLabel>
                </>
              ))}

              <RB.Button variant="primary" type="submit" className="mt-3">
                Submit
              </RB.Button>
            </RB.Form>
          </RB.Card.Body>
        </RB.Card>
      </div>
      <RB.Modal
        show={showModal}
        onHide={() => {
          setShowModal(false);
          setZoomLevel(1);
        }}
        centered
        size="lg"
      >
        <RB.Modal.Header closeButton>
          <RB.Modal.Title>Image Preview</RB.Modal.Title>
        </RB.Modal.Header>
        <RB.Modal.Body className="text-center">
          {modalImage ? (
            <div
              onWheel={(e) => {
                e.preventDefault();
                setZoomLevel((prevZoom) => {
                  const delta = e.deltaY > 0 ? -0.1 : 0.1; // Scroll down = zoom out
                  const newZoom = prevZoom + delta;
                  return Math.min(3, Math.max(0.5, newZoom));
                });
              }}
              style={{
                overflow: "auto",
                cursor: "zoom-in",
              }}
            >
              <img
                src={modalImage}
                alt="Preview"
                style={{
                  transform: `scale(${zoomLevel})`,
                  transition: "transform 0.2s",
                  maxWidth: "100%",
                  maxHeight: "70vh",
                  objectFit: "contain",
                }}
              />
              <div className="text-muted mt-2" style={{ fontSize: "12px" }}>
                Scroll to zoom in/out
              </div>
            </div>
          ) : (
            <p>No image available</p>
          )}
        </RB.Modal.Body>
      </RB.Modal>
    </>
  );
}

export default PopupGiftForm;
